export const minutesToSeconds = (minutes: number): number => {
	return minutes * 60;
};

export const hoursToSeconds = (hours: number): number => {
	return hours * 3600;
};

export const daysToSeconds = (days: number): number => {
	return days * 86400;
};

export const convertSecondsToTime = (seconds: number): string => {
	const minutes = Math.floor((seconds % 3600) / 60);
	const hours = Math.trunc(seconds / 3600);

	return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const snakeToCamel = (str: string): string => {
	return str
		.toLowerCase()
		.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
};
